import { AgGridReact } from 'ag-grid-react';
import { useRef } from 'react';
import { PortfolioCompanyResponse } from '~/api/def/endpoints/portfolioCompanyEndpoint';
import { agTheme } from '~/components/ui/tables/ag/agTheme';
import { colDefsPortfoliosTableGet } from './colDefsPortfoliosTable';

export type PortfoliosTableProps = {
  rowData: PortfolioCompanyResponse[];
  loading: boolean;
  fundId?: string;
  fundName?: string;
};

export const PortfoliosTable = ({
  rowData,
  loading,
  fundName,
  fundId,
}: PortfoliosTableProps) => {
  const gridRef = useRef<AgGridReact<PortfolioCompanyResponse>>(null);
  return (
    <div style={{ height: '100%' }}>
      <AgGridReact
        rowHeight={55}
        rowData={rowData}
        ref={gridRef}
        loading={loading}
        defaultColDef={{
          floatingFilter: true,
          suppressHeaderMenuButton: false,
          filter: 'agTextColumnFilter',
        }}
        columnDefs={colDefsPortfoliosTableGet(fundId, fundName)}
        tooltipShowDelay={0}
        theme={agTheme}
        suppressHorizontalScroll
        colResizeDefault="shift"
        suppressCellFocus
        onColumnResized={(params) => {
          if (params.finished) params.api.sizeColumnsToFit();
        }}
        autoSizeStrategy={{
          type: 'fitGridWidth',
          defaultMinWidth: 100,
        }}
      />
    </div>
  );
};
